import { buildBodyRootMap, findBodyForJointUuid } from "../../utils/bodyHierarchy";
import {
  generateActuatorControlName,
  generateStableActuatorNameFromUuid,
} from "../../utils/actuatorIds";
import type { Actuator, BodyRecord, JointRecord, WorldBodyEntry } from "./types";

/**
 * Slider / physics-store keys used while physics is off (aligned with ActuatorControlsPanel).
 */
export function resolveUiActuatorControlKey(
  actuator: Actuator,
  sceneState: {
    joints?: JointRecord;
    bodies?: BodyRecord;
    worldBodies?: WorldBodyEntry[];
  }
): string {
  if (actuator?.uuid) {
    return generateStableActuatorNameFromUuid(actuator.uuid);
  }
  const joints = sceneState?.joints || {};
  const bodies = sceneState?.bodies || {};
  const worldBodies = Array.isArray(sceneState?.worldBodies) ? sceneState.worldBodies : [];
  const jointUuid = typeof actuator?.joint === "string" ? actuator.joint : null;
  const hostBodyUuid = jointUuid ? findBodyForJointUuid(bodies, jointUuid) : null;
  const bodyRootMap = buildBodyRootMap(bodies || {}, worldBodies);
  const rootUuid = hostBodyUuid ? bodyRootMap[hostBodyUuid] || hostBodyUuid : null;
  const jointName = jointUuid ? joints[jointUuid]?.name : null;
  const baseName = actuator?.name || jointName || actuator?.tendon || "actuator";
  return generateActuatorControlName({
    baseName,
    jointUuid,
    rootBodyUuid: rootUuid || null,
    tendonName: actuator?.tendon || null,
  });
}
